var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"exportreport_cell"},[_c('v-btn',{attrs:{"icon":"","disabled":_vm.isDownloadDisabled},on:{"click":function($event){return _vm.download()}}},[_c('v-icon',{class:{'material-icons-outlined':(true)},attrs:{"large":"","color":"#8F24D3"}},[_vm._v(" file_download ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }